/*
 * Design note for this app shell:
 * The site uses a dark-first Command Secrets theme so the editorial, high-contrast
 * intelligence aesthetic remains consistent across all routed pages.
 */

import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { Route, Switch } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import Home from "@/pages/Home";
import Access from "@/pages/Access";
import Disclaimer from "@/pages/Disclaimer";
import Privacy from "@/pages/Privacy";
import Cancellation from "@/pages/Cancellation";
import Support from "@/pages/Support";
import Security from "@/pages/Security";
import SingaporeLegal from "@/pages/SingaporeLegal";
import SupportInbox from "@/pages/SupportInbox";
import UkLegal from "@/pages/UkLegal";
import Payments from "@/pages/Payments";
function Router() {
  // make sure to consider if you need authentication for certain routes
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/access-options" component={Access} />
      <Route path="/legal/disclaimer" component={Disclaimer} />
      <Route path="/legal/privacy" component={Privacy} />
      <Route path="/legal/cancellation" component={Cancellation} />
      <Route path="/legal/singapore" component={SingaporeLegal} />
      <Route path="/legal/uk" component={UkLegal} />
      <Route path="/support" component={Support} />
      <Route path="/support/inbox" component={SupportInbox} />
      <Route path="/payments" component={Payments} />
      <Route path="/security" component={Security} />
      <Route path="/404" component={NotFound} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="dark">
        <TooltipProvider>
          <Toaster />
          <Router />
        </TooltipProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
